







// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import EditBasePiscine from '@/components/administration/piscine/edit/EditBasePiscine.vue'
import EditBasePage from '@/components/shared/EditBasePage.vue'
import { AloPiscine,getDefaultAloPiscine } from '@/models/alo/AloPiscine'
import { AloMns, getDefaultAloMns } from '@/models/alo/AloMns'
import { toNumberDictionary } from '@/utils/groupBy'
import { getImageUrl } from '@/utils/images'

@Component({
  name: 'EditMns',     
  components:{EditBasePiscine,EditBasePage}
})
export default class EditMns extends Vue {
      
  private piscine:AloPiscine = getDefaultAloPiscine()
  private selectedMnsId = 2

  get getImageUrl(){
    return getImageUrl
  }

  edit(item:AloPiscine) {            
    this.piscine = (this.$refs.baseEdit as EditBasePiscine).edit(item)
  }        

  get dicPiscineMns(){
    return toNumberDictionary(this.piscine.mns,m => m.id)
  }

  get mnsList(){
    return this.$store.myGetters.mnsList.filter(m => !this.dicPiscineMns[m.id])
  }  
  
  get mnsDic(){
    return this.$store.myGetters.mnsDic
  }  

  removeMns(mns:AloMns) {
    const index = this.piscine.mns.findIndex(it => it.id == mns.id);
    if(index > -1) this.piscine.mns.splice(index,1);
  }

  addMns(){
    const index = this.piscine.mns.findIndex(it => it.id == this.selectedMnsId);
    if(index == -1) this.piscine.mns.push(this.mnsDic[this.selectedMnsId])
  }

  created(){
    this.$store.myActions.ADM_MNS_ENSURE()
  }
}
